window.theme.scrollTo = (elementTop) => {
  const stickyHeaderHeight = document.querySelector('[data-header-height]') ? document.querySelector('[data-header-height]').getBoundingClientRect().bottom : 0;

  window.scrollTo({
    top: elementTop + window.scrollY - stickyHeaderHeight,
    left: 0,
    behavior: 'smooth',
  });
};
